import { render } from "./AnnexAlarmFeatures.vue?vue&type=template&id=37c8e186&ts=true"
import script from "./AnnexAlarmFeatures.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmFeatures.vue?vue&type=script&lang=ts"

import "./AnnexAlarmFeatures.vue?vue&type=style&index=0&id=37c8e186&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__